/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ex_IntroInputs */

const en_sorter_ex_intro = /** @type {(inputs: Sorter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys are reordered at the top level and inside the nested object. The array keeps its original element order.`)
};

const ko_sorter_ex_intro = /** @type {(inputs: Sorter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최상위와 중첩 객체 내부에서 키가 다시 정렬됩니다. 배열은 원래 요소 순서를 유지합니다.`)
};

const ja_sorter_ex_intro = /** @type {(inputs: Sorter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最上位とネストしたオブジェクトの内部でキーが並べ替えられます。配列は元の要素順序を保ちます。`)
};

/**
* | output |
* | --- |
* | "Keys are reordered at the top level and inside the nested object. The array keeps its original element order." |
*
* @param {Sorter_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ex_intro = /** @type {((inputs?: Sorter_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ex_intro(inputs)
	if (locale === "ko") return ko_sorter_ex_intro(inputs)
	return ja_sorter_ex_intro(inputs)
});